import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Cog, Loader2 } from "lucide-react";

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("admin@attuatori.it");
  const [password, setPassword] = useState("admin123");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      if (mode === "login") await login(email, password);
      else await register(name, email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 relative bg-[#0A192F]">
        <img
          src="https://images.pexels.com/photos/18568174/pexels-photo-18568174.jpeg"
          alt="Impianto industriale"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/60 to-transparent" />
        <div className="relative z-10 flex flex-col justify-end p-12 text-white">
          <div className="font-mono-label text-xs text-[#4d94ff] mb-3">GESTIONE COMMERCIALE</div>
          <h1 className="font-display font-black text-4xl leading-tight tracking-tight">
            Il tuo business di attuatori lineari, in un unico posto.
          </h1>
          <p className="text-slate-300 mt-4 max-w-md text-sm">
            Contatti, offerte, pipeline di vendita e catalogo tecnico. Tutto centralizzato.
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 bg-[#0052CC] rounded-sm flex items-center justify-center text-white">
              <Cog className="w-5 h-5" />
            </div>
            <div className="font-display font-black text-xl tracking-tight text-slate-900">LINEARCRM</div>
          </div>

          <h2 className="font-display font-bold text-2xl text-slate-900">
            {mode === "login" ? "Accedi al CRM" : "Crea account"}
          </h2>
          <p className="text-sm text-slate-500 mt-1 mb-6">
            {mode === "login" ? "Inserisci le tue credenziali per continuare." : "Registra un nuovo utente."}
          </p>

          <form onSubmit={submit} className="space-y-4">
            {mode === "register" && (
              <div>
                <Label className="font-mono-label text-[10px] text-slate-500">Nome</Label>
                <Input data-testid="register-name-input" value={name} onChange={(e) => setName(e.target.value)}
                  required className="mt-1.5 rounded-sm focus:ring-2 focus:ring-[#0052CC]" placeholder="Mario Rossi" />
              </div>
            )}
            <div>
              <Label className="font-mono-label text-[10px] text-slate-500">Email</Label>
              <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required className="mt-1.5 rounded-sm focus:ring-2 focus:ring-[#0052CC]" placeholder="nome@azienda.it" />
            </div>
            <div>
              <Label className="font-mono-label text-[10px] text-slate-500">Password</Label>
              <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required className="mt-1.5 rounded-sm focus:ring-2 focus:ring-[#0052CC]" placeholder="••••••••" />
            </div>

            {error && <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-sm px-3 py-2">{error}</div>}

            <Button data-testid="login-submit-btn" type="submit" disabled={loading}
              className="w-full bg-[#0052CC] hover:bg-[#003D99] rounded-sm h-11 font-medium transition-colors duration-200">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              {mode === "login" ? "Accedi" : "Registrati"}
            </Button>
          </form>

          <button
            data-testid="toggle-auth-mode"
            onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
            className="mt-6 text-sm text-slate-500 hover:text-[#0052CC] transition-colors duration-200"
          >
            {mode === "login" ? "Non hai un account? Registrati" : "Hai già un account? Accedi"}
          </button>
        </div>
      </div>
    </div>
  );
}
